// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__nyY4t","alert":"SettungsInbox_alert__1EZii"};